// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1414":"css/app.7058","1648":"css/admin-app.7058"}[chunkId] + ".css";
};